
const contentData = {
    "patch": "Powered by Virdio",  // COMMON  FOR HIST AND GUEST
    "online": "online",
    "offline": "offline",
    "by":"by ",
    "startsession": {"name":"Start Class","tooltips":"Allow everyone to enter your virtual studio"},
    "sessionStarted":"Class Started",
    "setting":{"name":"Settings","tooltip":"Instructor Settings"},
    "sessionDetails":{"name":"Details","tooltip":"Class Details"}, 
    "close":{"name":"Close","tooltip":"Leave the Class"},   
    "muteunmute":{"name":"Mute/Unmute","tooltip":"Allow everyone to talk"},
    "participantview":{"headingName":"Member View","name":"List","listToolTip":"View Member List"},
    "onscreen":"On Screen:",
    "expand":{"name":"Expand","tooltip":"Increase the area of streaming section"},
    "streaming":"Streaming",
    "mic":{"name":"Mic","tooltips":"Microphone Settings"},
    "camera":{"name":"Camera","tooltips":"Switch current camera"},
    "startrecording":{"name":"Start","tooltips":"Start Recording Class"},
    "stoprecording":{"name":"Stop","tooltips":"Stop Recording Class"},
    "playlist":{"name":"Music","tooltips":"Music Controls"},
    "zoomtooltips":"Zoom my stream view",
	"hideEmoji" : "Hide emoji",
	"showEmoji" : "Show or Hide emoji bar",
    "musicPlaPopUp":{"title":"Eject from Class","public":"Public Conversation","private":"Private Conversation","emotions":"Emotions"},
    "script":
    {
      "scriptHeading":"Fitness Script",
      "countName":" fitness",
      "start":"START",
      "startTopRight":"Start",
      "startTooltips":"Start workout script",
      "pauseTopRight":"Pause",
      "pauseTooltips":"Pause workout script",
      "stoptTopRight":"Stop",
      "stopTooltips":"Stop and go to start of script",
      "scriptTopRight":"Script",
      "scriptTooltips":"View script details",
      "nextTopRight":"Next",
      "scriptEnd":"End of Script"
    },

      "sessionPopUp":{"heading":"Class Starting","bodyMsg":"Class is about to start. Press the Start Class button on the screen or remote to allow everyone to enter the virtual studio","okBtn":"OK"},

      "recordingPopUp":{"heading":"Uploading","bodyMsg":"Please wait while your recordings are being saved..."},

      "sessionStartedPopUp":{"heading":"Class Started","msgPart1":"Your class started","msgPart2":"ago, when you are ready press the Start Class button to on the screen or the remote to allow everyone to enter the virtual studio"},

      "playList":{"heading":"Playlist","noList":"No Playlist"},

      "recordingModelPopUp":{"heading":"Class Recording","bodyMsg":"To be able to recording class on Safari you need to turn recording on in your browser. To do this click on <b>Develop</b> in top menu, and inside <b>Experimental Features</b> turn <b>MediaRecorder</b> on.<br /><br />If you are unable to find <b>Develop</b> in your top menu, go to <b>Safari > Preferences</b> and inside <b>Advanced</b> tab turn on <b>Show Develop menu</b> option."},

      "logOutSession":{"heading":"Logout Class","msgPart1":"Your class still has","msgPart2":"until completion, do you plan to rejoin the class or have you completed the class?","rejoin":"Re-Join","complete":"Completed"},

      "fitnessScript":{"title":"Fitness Script","name":"Name","type":"","durrType":"Duration type","count":"Counts (Reps/Secs)","targetZone":"Target Zone","tagetBPM":"Target BPM","video":"Video"},

      "switchCamera":{"title":"Select Video Camera","switch":"Switch"},
      "switchMicrophone":{"title":"Select Microphone","switch":"Switch"},
      "switchSpeakers":{"title":"Select Speaker","switch":"Switch"},

      "hostSetting":{
                      "recordingTitle":"Start Recording at Start Script",
                      "recordingTooltip":"Your recording will start​ automatically when your script starts, or if you do not have​ a script when you press Start Class. This feature is disabled​ once the Script starts.",
                      "musicTitle":"Start Music at Start Script",
                      "musicTooltip":"Your Playlist will start ​automatically when you start the Script. This feature is disabled once the Script starts.",
                      "otherParticipant":"Show other Members",
                      "otherParticipantTooltip":"This allows the Members in the​ Class to see each other on the side of their screens.",
                      "switchPIP":"Switch Instructor/Member PIP",
                      "switchPIPTooltip":"This feature allows you to ​switch the location of the Instructor and Member during the ​Class.",
                      "shopping":"Shopping List",
                      "shoppingToolTip":"Shopping List",
                      "equipment":"Equipment List",
                      "equipmentToolTip":"Equipment List",
                      "resolutionCustom":"Custom Resolution",
                      "resolutionHighPP": "4K Definition",
                      "resolutionHighP2": "1440p Definition",
                      "resolutionHighP": "1080p Definition",
                      "resolutionHigh":"High Definition",
                      "resolutionStd":"Standard Definition",
                      "resolutionLow":"Low Definition",
                      "saveBtn":"Save",
                      "switchHostParticipant":"Switch Instructor and Member",
                      "switchHostParticipantTooltip":"This feature allows you to ​switch the location of the Instructor and Member during the ​Class.",
                      "disableNotificationSound": "Disable Notification Sound",
                      "disableNotificationSoundTooltip":"If you want to turn off the ​sounds when a Member joins or leaves the Class, Turn​ this feature on.",
                      "turnoffRoomSetup": "Turn Off Room Setup",
					  "calculateAssessmentDimensions": "Calculate Assessment Dimensions",
					  "calculateAssessmentDimensionsTip": "Calculate Assessment Dimensions",
                      "turnoffRoomSetupTooltip":"Turn Off Room Setup."
                    },

      /**** FOR GUEST CONTENT ****/
      "heartRate":{"name":"Heart Rate","tooltips":"Download the Virdio App to track your heart rate","no20":"20","no40":"40","no60":"60","no80":"80","no100":"100","no120":"120","no140":"140","no160":"160","no180":"180","no200":"200","no220":"220","skillBpm":"140"},
      "guestLocalZoom":"Zoom local stream",
      "muteHost":"Mute Instructor",
      "handRaise":"Raise Hand to ask question",
      "testmic":"Microphone Settings",
      "participantSettings":"Equipment settings",
      "testmicshort":"Test Mic",
      "micOn":"Microphone On",
      "micOff":"Microphone Off",
      "hideVideoList":"Hide Video List",
      "backbtn":"Press back button",
      "details":"Details",
      "privacy":"Privacy",
      "emoji":{"name":"How are you feeling?","like":"like","dislike":"dislike","easy":"easy","toHard":"toohard","perfect":"perfect","awesome":"awesome"},

      "multipleDevice":{"heading":"Multiple Device Login","msg":"Another device has logged in using the same email address. You are being logged out from this class.  If you did not authorize the other login, please change your password.","btn":"OK"},

      "microphonePopUp":{"heading":"Microphone","msg":"Your microphone is currently Muted.  To ask questions during the class, press the Hand button and your instructor can open your microphone.","notShow":"Don’t show again","btn":"OK"},

      "guestfitnessPopUp":{"time":"Time","edt":"EDT","length":"Length","signup":"Signed Up","revenue":"Revenue","amt":"$2,000","attenPrivacy":"Attendee Privacy","statment1":"Allow attendees to block video stream to other attendees","statment2":"Allow attendees to block direct message to other attendees","statment3":"Allow attendees to select their own playlist","equipment":"Equipment","item":"Dumbbell 2kg, 5kg","item1":"stretching Belt, 1.5m","shopping":"Shopping List","item2":"Ironcast Dumbell, 10kg, 5kg, 3kg and more","item3":"Stretching rubber belt, 1.5m, 2m, 3m","item4":"Uppercast support for back","item5":"Ancle bands sizes M, S, XL, XS","hoststatment1":"Allow other users to see my name and picture","hoststatment2":"Allow other users to send me private message","hostItem1":"Corkscrew Wine Opener","hostsItem2":"4 wine glasses per taster. Preferably two white and two red","hostItem3":"Lynmar Estates: 2014 Bliss Block Pinot Noir","hostItem4":"Lynmar Estates: 2016 Block 10 Pinot Noir","hostItem5":"Lynmar Estates: Quail Hill Estates Chardonnay 2016"},

      "wine":{"title":"Order Wines that were tasted","name":"Wine Name","score":"Score","price":"Price","qty":"Quantity","total":"Total","orderHost":"Order From Instructor","cancel":"Cancel"},

      /****HOST CONTROLLER STATIC ****/
      "browserNotSupport":"Your browser does not support WebRTC!",
      "messagePeer":"MessageFromPeer",
      "connectionState":"ConnectionStateChanged",
      "remoteLogin":"REMOTE_LOGIN",
      "aborted":"ABORTED",
      "disconnected":"DISCONNECTED",
      "loginTimeout":"LOGIN_TIMEOUT",
      "intrupted":"INTERRUPTED",
      "loginFailure":"LOGIN_FAILURE",
      "bannedByServer":"BANNED_BY_SERVER",
      "text1100":"1100",
      "videoResolution":"video-resolution",
      "dynamicKeyTime":"DYNAMIC_KEY_TIMEOUT",
      "mediaSetting":"media-setting",
      "disconnecting":"DISCONNECTING",
      "tempUsers":"tempUsers",
      "userData":"userData",
      "granted":"Granted",
      "denied":"Denied",
      "participantList":"Member List",
      "inSession":" in class",
      "recordingBtnPressed":"Recording button pressed",
      "stopRecordBtnPressed":"Stop recording button pressed",
      "recordingExist":"Recording exist and will process",
      "recordingStarted":"Recording upload started",
      "recordingUploadCompleted":"Recording upload completed",
      "remote": {
          "script":"script",
          "handRaise":"handRaise",
          "playlist":"playlist",
          "hostSetting":"hostSetting",
          "camera":"camera",
          "maxonscreen":"maxonscreen",
          "selectParticipant":"selectParticipant",
          "participantlist": "participantList",
          "msgTextInfo":"Press OK to open microphone",
          "sessionDetails": "sessionDetails",
          "zoomHostStream":"zoomHostStream",
          "poorNetwork":"Poor network",
          "microphone":"microphone"
      }
    
}
 
export default contentData
